/**
 * Puente entre el proveedor de autenticacion activo (Clerk) y los repositorios
 * "remote", que llaman a la API y necesitan un JWT valido en cada peticion.
 * ClerkAuthProvider registra aqui el getToken() real cuando el usuario esta logueado.
 */
type TokenGetter = () => Promise<string | null>;

let currentTokenGetter: TokenGetter = async () => null;

export function setTokenProvider(fn: TokenGetter): void {
  currentTokenGetter = fn;
}

export function getAuthToken(): Promise<string | null> {
  return currentTokenGetter();
}
